import React, {useState} from 'react'
import {Block, Col, Row} from 'jsxstyle'

import FormInput from '../FormInput'
import {DialogProps} from '../Dialog/Dialog'
import ConfirmDialog from '../ConfirmDialog'

type ActivityLogsDialogProps = Omit<DialogProps, 'children'> & {
  title: string
  subtitle: string
  sendLabel: string
  placeholder?: string
  onSend: (inputValue: string) => void
  onCancel: () => void
  maxWidth?: string
  overflowY?: string
}

const ActivityLogsDialog: React.FC<ActivityLogsDialogProps> = ({
  title,
  subtitle,
  sendLabel,
  placeholder,
  onSend,
  onCancel,
  maxWidth = '500px',
  overflowY = '',
  ...props
}) => {
  const [inputValue, setInputValue] = useState('')

  return (
    <ConfirmDialog {...props} maxWidth={maxWidth} overflowY={overflowY}>
      <Col padding="24px" backgroundColor="white" borderRadius="16px">
        <Block marginBottom="24px" textAlign="center">
          <Block fontSize="20px" fontWeight={500} color="#111827">
            {title}
          </Block>
          <Block paddingRight="20px" paddingLeft="20px" fontSize="14px" color="#6B7280" marginTop="4px" lineHeight="1.5">
            {subtitle}
          </Block>
        </Block>

        <FormInput
          minHeight="100px"
          maxHeight="100px"
          placeholder={placeholder}
          value=""
          onSubmit={(value) => setInputValue(value)}
          debounce={100}
          error={''}
        />

        <Row marginTop="24px" justifyContent="center" gap="16px" textAlign="center">
          <Row
            component="button"
            padding="12px 18px"
            width="50%"
            borderRadius="12px"
            border="1px solid #7A42C2"
            color="#7A42C2"
            backgroundColor="#FFFFFF"
            hoverBackgroundColor="#7A42C2"
            hoverColor="#F7F8F9"
            fontWeight={500}
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            props={{
              onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation
                onCancel()
              },
            }}
          >
            Cancel
          </Row>
          <Row
            component="button"
            padding="12px 18px"
            width="50%"
            borderRadius="12px"
            backgroundColor="#7A42C2"
            hoverBackgroundColor="#7A22C2"
            fontWeight={500}
            color="#F7F8F9"
            fontSize="12px"
            cursor="pointer"
            alignItems="center"
            justifyContent="center"
            props={{
              onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation
                onSend(inputValue)
              },
            }}
          >
            {sendLabel}
          </Row>
        </Row>
      </Col>
    </ConfirmDialog>
  )
}

export default ActivityLogsDialog
